import LZString from "lz-string";
import { Song } from "#models/song.ts";

export function serializeSong(song: Song): string {
  const json = JSON.stringify(song.serialize());
  const compressed = LZString.compressToBase64(json);
  return encodeURIComponent(compressed);
}

export function deserializeSong(compressedString: string): Song {
  let base64 = compressedString;
  try {
    base64 = decodeURIComponent(compressedString);
  } catch {
    // If decodeURIComponent fails (e.g. malformed URI), use original string
    base64 = compressedString;
  }

  const json = LZString.decompressFromBase64(base64);
  if (!json) {
    throw new Error("Failed to decompress LZString song data");
  }

  const data = JSON.parse(json) as Parameters<typeof Song.deserialize>[0];
  return Song.deserialize(data);
}
